<app-flag-container-v2
  [id]="id"
  [discount]="discount"
  [fixed]="lockedBackground"
  [divisionName]="divisionName.toLowerCase()"
  [service]="service"
  [classes]="classes"
  [game]="game"
  [state]="state"
>

  <!-- TODO move all to templates tags and reuse as needed? -->


  <!------------------------------------------------------------------------------------------------------------------
  Rank Selector
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="showRankSelect || showDivisionSelect || showRankSelectExtended || showRank"  class="flag-rank text-bj"
    [class.solo]="state"
    [class.extra-margin]="((game === 'lol' || game === 'tft' || game === 'wild-rift') && service === 'normalgames' && !state)">
    <img *ngIf="(game !== 'cs2') && (service !== 'placements' || game === 'lol' || game === 'tft' || game === 'valorant' || game === 'wild-rift')"
      class="flag-rank__icon" [ngClass]="{'overwatch-img': game === 'overwatch', 'extra-val-margin': game === 'valorant' && service !== 'normalgames'}"
      src="{{'https://cdn.ggboost.com/images/ranks/'}}{{game}}/{{currentValue}}{{'.webp' | cdn}}"
      [alt]="game + ' ' + DivisionsService.getRankByValue(currentValue,game) + ' rank'"
      (click)="(showDivisionSelect || showRankSelect) && (showDivisionSelect ? onOpenDivisionSelector() : onOpenRankSelector())"
    >
    <img *ngIf="service === 'placements' && game === 'apex'"
      class="flag-rank__icon" [ngClass]="{'overwatch-img': game === 'overwatch'}"
      src="{{'https://cdn.ggboost.com/images/ranks/'}}{{game}}/{{currentValue}}{{'.webp' | cdn}}"
      [alt]="game + ' ' + DivisionsService.getRankByValue(currentValue,game) + ' rank'"
      (click)="(showDivisionSelect || showRankSelect) && (showDivisionSelect ? onOpenDivisionSelector() : onOpenRankSelector())"
    >
    <div *ngIf="game === 'cs2' && queue === 'premier' && !state" class="cs2-rank-selector">
      <div [ngClass]="{'cs2-input-wrapper': true, 'edit-icon': service !== 'placements', 'selectable': id === 'desired'}" (click)="handleClick()">
        <cs2-svg-selector [rankValue]="currentValue"></cs2-svg-selector>
        <input #currentRankInput *ngIf="id === 'current' && service !== 'placements'" class="cs2-rank-input"
          [style.color]="cs2RanksToColor(currentValue)"
          [value]="formattedValue"
          (input)="onInputChange($event)"
          (keyup)="onAmountManualChange($event)"
          (change)="onAmountManualChange($event)"
          (blur)="onInputBlur($event)"
          (focus)="onInputFocus($event)"
          type="text"
          pattern="\d*">
        <span *ngIf="id === 'desired'" [style.color]="cs2RanksToColor(currentValue)" class="cs2-rank-input">{{formatNumberWithCommas((currentValue * 1000).toString())}}</span>
        <span *ngIf="service === 'placements'" [style.color]="cs2RanksToColor(0)" class="cs2-rank-input unranked">Unranked</span>
      </div>
      <span class="flag-rank__subdivision">CS Rating</span>
    </div>

    <div *ngIf="game === 'cs2' && queue === 'premier' && state" class="cs2-rank-selector" [style.padding-top]="service==='placements' || service==='netwins' ? '14px' : ''">
      <!-- <div class="cs2-wrapper"> -->
        <cs2-svg-selector [rankValue]="currentValue" [showRating]="true" [rating]="(lp ? currentValue*1000+lp : currentValue*1000) === 0 ? '-' : (lp ? currentValue*1000+lp : currentValue*1000)"></cs2-svg-selector>
      <!-- </div> -->
    </div>

    <div *ngIf="(game === 'cs2' && queue === 'competitive')" [class.cs-solo]="state">
      <img
        class="flag-rank__icon competitive-rank-img"
        src="{{'https://cdn.ggboost.com/images/ranks/cs2/competitive/'}}{{currentValue}}{{'.webp' | cdn}}"
        [alt]="game + ' ' + DivisionsService.getMasteryName(currentValue,game) + ' rank'"
        (click)="service !== 'placements' && onOpenRankSelector()"
      >
      <div *ngIf="!state" class="val-margin" [ngClass]="service !== 'placements' ? 'editable-modern' : ''" (click)="service !== 'placements' && onOpenRankSelector()">
        <div *ngIf="currentValue <= 4 ">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
            Division {{DivisionsService.getMasteryName(currentValue, game).split(' ')[1]}}
            <i *ngIf="service !== 'placements'" class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="currentValue === 5">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
            {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}} Division
            <i class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="currentValue === 6 || currentValue === 10">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
            {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}}
            <i class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="(currentValue >= 7 && currentValue <=9)">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
           Division {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}}
            <i class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="(currentValue >= 11 && currentValue <= 14) || currentValue === 16 || currentValue === 18">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(1, 3).join(' ')}}
            <i class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="currentValue === 15">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ')[1]}}
            <i class="arrow-down"></i>
          </span>
        </div>
        <div *ngIf="currentValue === 17">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(1, 4).join(' ')}}
            <i class="arrow-down"></i>
          </span>
        </div>

        <span *ngIf="service !== 'placements'" class="val-selector-up val-selector-up-big"></span>
        <span *ngIf="service !== 'placements'" class="val-selector-down val-selector-down-big"></span>
      </div>

      <div *ngIf="state" class="val-margin">
        <div *ngIf="currentValue <= 4 ">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
            Division {{DivisionsService.getMasteryName(currentValue, game).split(' ')[1]}}
          </span>
        </div>
        <div *ngIf="currentValue === 5">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
            {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}} Division

          </span>
        </div>
        <div *ngIf="currentValue === 6 || currentValue === 10">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
            {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}}

          </span>
        </div>
        <div *ngIf="(currentValue >= 7 && currentValue <=9)">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(0, 2).join(' ')}}</span>
          <span class="flag-rank__subdivision">
           Division {{DivisionsService.getMasteryName(currentValue, game).split(' ')[2] || ""}}

          </span>
        </div>
        <div *ngIf="(currentValue >= 11 && currentValue <= 14) || currentValue === 16 || currentValue === 18">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(1, 3).join(' ')}}

          </span>
        </div>
        <div *ngIf="currentValue === 15">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ')[1]}}

          </span>
        </div>
        <div *ngIf="currentValue === 17">
          <span class="flag-rank__division">{{DivisionsService.getMasteryName(currentValue, game).split(' ')[0]}}</span>
          <span class="flag-rank__subdivision">
           {{DivisionsService.getMasteryName(currentValue, game).split(' ').slice(1, 4).join(' ')}}

          </span>
        </div>
      </div>
    </div>

    <div *ngIf="showRankSelect || showDivisionSelect || showRankSelectExtended || showRank"
      [class.editable]="!showRank && (showDivisionSelect || showRankSelect) && (game === 'lol' || game === 'tft' || game === 'wild-rift')"
      [class.editable-modern]="!showRank && ((showDivisionSelect || showRankSelect) && (game === 'valorant' || game === 'apex' || game === 'marvel' || game === 'overwatch'))"
      [class.val-margin]="game==='valorant' || game === 'apex' || game === 'marvel' || game === 'overwatch'"
      [class.fake-selector-hover]="autoFlash"
      [class.fake-edit-pencil-hover]="autoFlash"
      (click)="!showRank && showDivisionSelect ? onOpenDivisionSelector() : onOpenRankSelector()"
      (mouseover)="turnOffAutoFlash()"
    >
      <span *ngIf="!showRank && (game === 'valorant' || game === 'apex' || game === 'marvel' || game === 'overwatch')" class="val-selector-up val-selector-up-big"></span>
      <span *ngIf="!showRank && (game === 'valorant' || game === 'apex' || game === 'marvel' || game === 'overwatch')" class="val-selector-down val-selector-down-big"></span>

      <ng-container *ngIf="divisionName === 'Grandmaster' && game === 'lol'; else next1">
        <span class="flag-rank__division">Grand</span>
        <span class="flag-rank__subdivision">Master <i class="arrow-down"*ngIf="!showRank"></i></span>
      </ng-container>

      <ng-template #next1>
        <ng-container *ngIf="divisionName === 'Top' && game === 'overwatch'; else next2">
          <span class="flag-rank__division">Top 500
              <i class="arrow-down" *ngIf="!showRank"></i>
          </span>
        </ng-container>
      </ng-template>

      <ng-template #next2>
        <ng-container *ngIf="game !== 'cs2' && !showDivisionSelect && game !== 'lol' && game !== 'tft' && game !== 'wild-rift' && game !== 'apex' && game !== 'valorant'">
          <span class="flag-rank__division">{{divisionName}}</span>
          <span class="flag-rank__subdivision" *ngIf="game !== 'valorant'">
            {{ rankName }}
            <i class="arrow-down"*ngIf="!showRank"></i>
          </span>
        </ng-container>

        <ng-container *ngIf="game === 'lol' || game === 'tft' || game === 'wild-rift' || game === 'apex'">
          <span class="flag-rank__division">
            {{ divisionName.split(' ')[0] }}
          </span>

          <span class="flag-rank__subdivision">
            {{ rankName }} {{ (divisionName.startsWith('Diamond') && showDivisionSelect && game === 'wild-rift' ? divisionName.split(' ')[1] : '' ) }}
            <i class="arrow-down"*ngIf="!showRank"></i>
          </span>
        </ng-container>

        <ng-container *ngIf="game === 'valorant'">
          <span class="flag-rank__division">
            {{ divisionName.split(' ')[0] }}
          </span>

          <span class="flag-rank__subdivision">
             {{ rankName }} {{ ((divisionName.startsWith('Diamond') || divisionName.startsWith('Ascendant') || divisionName.startsWith('Immortal')) && showDivisionSelect ? divisionName.split(' ')[1] : '' ) }}
            <i class="arrow-down"*ngIf="!showRank"></i>
          </span>
        </ng-container>

      </ng-template>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Champion
  ------------------------------------------------------------------------------------------------------------------->
  <div class="flag-champion text-bj" *ngIf="game === 'lol' && service ==='masteries'">
    <div
      class="flag-champion__icon-wrapper"
      [class.editable]="showChampionSelect">
      <img *ngIf="champion !== ''"
        class="flag-champion__icon"
        src="https://cdn.ggboost.com/images/champions/{{champion}}.jpg"
        [alt]="'lol champion ' + champion"
        (click)="showChampionSelect && openCharacterSelect.emit()"
      >
    </div>
    <div
      [class.editable]="showMasterySelect"
      (click)="showMasterySelect && openMasterySelect.emit()"
    >
      <ng-container>
        <span class="flag-champion__mastery">Mastery {{currentValue}} <i class="arrow-down"></i></span>
        <span class="flag-rank__subdivision"></span>
      </ng-container>
      <!-- <ng-container *ngIf="currentValue === 5">
        <span class="flag-champion__mastery">Mastery 5</span>
        <span class="flag-rank__subdivision">0 Tokens <i class="arrow-down"></i></span>
      </ng-container>
      <ng-container *ngIf="currentValue === 6">
        <span class="flag-champion__mastery">Mastery 5</span>
        <span class="flag-rank__subdivision">1 Token <i class="arrow-down"></i></span>
      </ng-container>
      <ng-container *ngIf="currentValue === 7">
        <span class="flag-champion__mastery">Mastery 6</span>
        <span class="flag-rank__subdivision">0 Tokens <i class="arrow-down"></i></span>
      </ng-container>
      <ng-container *ngIf="currentValue === 8">
        <span class="flag-champion__mastery">Mastery 6</span>
        <span class="flag-rank__subdivision">1 Token <i class="arrow-down"></i></span>
      </ng-container>
      <ng-container *ngIf="currentValue === 9">
        <span class="flag-champion__mastery">Mastery 6</span>
        <span class="flag-rank__subdivision">2 Tokens <i class="arrow-down"></i></span>
      </ng-container>
      <ng-container *ngIf="currentValue === 10">
        <span class="flag-champion__mastery">Mastery 7 <i class="arrow-down"></i></span>
        <span class="flag-rank__subdivision"></span>
      </ng-container> -->
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Legend Selector Apex
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="(showChampion || showChampionSelect) && (game==='apex' && service === 'badges')" class="flag-legend text-bj" [class.solo]="state">
    <div class="flag-legend__icon-wrapper">
      <img *ngIf="champion !== ''"
        class="flag-legend__icon"
        src="https://cdn.ggboost.com/images/characters/apex/{{champion}}.webp"
        [alt]="'apex legends '+champion"
        (click)="openCharacterSelect.emit()">
    </div>
    <div class="flag-col">
      <p class="flag-region"
         [class.editable-small-modern]="showChampionSelect && game === 'apex' && !state"
         (click)="openCharacterSelect.emit()">
        <span *ngIf="game === 'apex' && !state" class="val-selector-up"></span>
        <span *ngIf="game === 'apex' && !state" class="val-selector-down"></span>
        <small *ngIf="!state">{{ 'legend' | translate: lang }}</small>
        {{champion}} <i class="arrow-down" *ngIf="!state"></i>
      </p>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Badge Selector Apex
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="(game==='apex' && service === 'badges' && id === 'current')" class="flag-badge text-bj" [class.solo]="state">
    <img
      src="https://cdn.ggboost.com/images/badges/apex/{{badge}}.webp"
      [alt]="'Apex Badge ' + DivisionsService.getBadgeTitle(badge, game) + ' Boosting'"
      (click)="openBadgeSelect.emit()"
    >
    <div class="flag-col">
      <p class="flag-region"
         [class.editable-small-modern]="game === 'apex' && !state"
         (click)="openBadgeSelect.emit()">
        <span *ngIf="game === 'apex' && !state" class="val-selector-up"></span>
        <span *ngIf="game === 'apex' && !state" class="val-selector-down"></span>
        <small *ngIf="!state">{{ 'badge' | translate: lang }}</small>
        {{DivisionsService.getBadgeTitle(badge, game)}} <i class="arrow-down" *ngIf="!state"></i>
      </p>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Amount Selector
  ------------------------------------------------------------------------------------------------------------------->
  <div class="flag-number" *ngIf="(showAmountSelect && min && max) || showNumber" [class.solo-number]="showNumber && state">
    <p *ngIf="!amountEdit">{{ currentValue }}</p>
    <input [(ngModel)]="currentValue" class="text-bj" type="number" *ngIf="amountEdit" (keyup)="onAmountManualChange($event)" (change)="onAmountManualChange($event)">
    <app-slider *ngIf="showAmountSelect"
      style="height: 24px;"
      [game]="game"
      [min]="min || 1"
      [max]="max || 2"
      [steps]="1"
      [initialValue]="currentValue"
      [currentValue]="currentValue"
      (slideNext)="currentValue=$event"
      (slideEnd)="amountChange.emit($event)">
    </app-slider>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Static Flag Type
  ------------------------------------------------------------------------------------------------------------------->
  <p *ngIf="state && (showNumber || game === 'cs2')" class="flag-rank__division state-type">
    <!-- {{ (game === 'cs2' && state === 'starting' ? 'initial' : state) | uppercase}} -->
    <ng-container *ngIf="map; else default">
      {{ map | uppercase}}
    </ng-container>

    <ng-template #default>
      {{ state | translate: lang | uppercase }}
    </ng-template>
  </p>

  <!------------------------------------------------------------------------------------------------------------------
  Service name display
  ------------------------------------------------------------------------------------------------------------------->
  <p *ngIf="serviceName">
    <ng-container *ngIf="state">
      {{ serviceName | translate: lang }}
    </ng-container>

    <ng-container *ngIf="!state">
      {{ serviceName }}
    </ng-container>
  </p>

  <p *ngIf="showBoosterAvailability" class="text-ovr" [class.top-spacing]="
    !serviceName &&
    !(showRankSelect || showDivisionSelect || showRankSelectExtended || showRank) &&
    !((showChampion || showChampionSelect) && (game==='apex' && service === 'badges'))
  ">
    <small *ngIf="game === 'lol' || game === 'tft' || game === 'wild-rift'">Master/Challenger Boosters</small>
    <small *ngIf="game === 'valorant'">Immortal III/Radiant Boosters</small>
    <small *ngIf="game === 'overwatch'">Grandmaster/Top500 Boosters</small>
    <small *ngIf="game === 'apex'">Master/Predator Boosters</small>
    <small *ngIf="game === 'cs2'">30K+ CS Rating / Global Elite Boosters</small>
    <small *ngIf="game === 'marvel'">Celestial/One Above All Boosters</small>
    {{ 'ready_5_min' | translate: lang | uppercase }}
  </p>

  <p *ngIf="completionTime" [class.top-spacing]="
    !serviceName && !showAmountSelect &&
    !(showRankSelect || showDivisionSelect || showRankSelectExtended || showRank) &&
    !((showChampion || showChampionSelect) && (game==='apex' && service === 'badges'))
  ">
    <small>{{ 'avg_comp_time' | translate: lang }}</small>
    {{ completionTime.split(' ')[0] }} {{ completionTime.split(' ')[1] | translate: lang }}
  </p>

  <!------------------------------------------------------------------------------------------------------------------
  Queue selector
  ------------------------------------------------------------------------------------------------------------------->
  <p
    class="flag-queue"
    *ngIf="(showQueueSelect || showQueue)"
    [class.editable]="showQueueSelect && (game === 'lol' || game === 'tft' || game === 'wild-rift') && (game !== 'apex')"
    [class.editable-small-modern]="showQueueSelect && (game === 'valorant' || game === 'apex' || game === 'cs2')"
    [class.competitive-placements-queue]="service === 'placements' && queue === 'competitive'"
    [class.top-spacing]="(service === 'leveling' && (game === 'lol'))"
    (click)="showQueueSelect && onOpenQueueSelector()"
  >
    <ng-container *ngIf="service === 'placements' && queue === 'competitive'; else defaultQueue">
      <small>{{ 'comp_queue' | translate: lang }}</small>
    </ng-container>
    <ng-template #defaultQueue>
      <small>{{ (game !== 'cs2' ? 'queue' : 'queue_cs') | translate: lang }}</small>
      <ng-container *ngIf="(game === 'lol' || game === 'wild-rift') && queue === 'soloq'">Solo</ng-container>
      <ng-container *ngIf="game === 'lol' && queue === 'draftq'">Draft</ng-container>
      <ng-container *ngIf="game === 'valorant' && service === 'normalgames'">Unrated</ng-container>
      <ng-container *ngIf="game === 'valorant' && service !== 'normalgames'">Ranked</ng-container>
      <ng-container *ngIf="(game === 'tft' && service !== 'normalgames' && queue === 'soloq')">Ranked</ng-container>
      <ng-container *ngIf="(game === 'tft' && queue === 'doubleup')">Double Up</ng-container>
      <ng-container *ngIf="(game === 'tft' && service === 'normalgames')">Normal</ng-container>
      <ng-container *ngIf="game ==='wild-rift' && queue !== 'soloq'">{{ queue }}</ng-container>
      <ng-container *ngIf="queue === 'flexq'">Flex</ng-container>
      <ng-container *ngIf="game === 'cs2'">{{queue}}</ng-container>
      <ng-container *ngIf="(game === 'apex' && queue === 'unranked')">Unranked</ng-container>
      <ng-container *ngIf="(game === 'marvel' && queue === 'quick')">Quick</ng-container>
      <ng-container *ngIf="showQueueSelect">&nbsp;<i class="arrow-down"></i></ng-container>
    </ng-template>

    <ng-container *ngIf="service === 'placements' && queue === 'competitive'">
      {{map + ' '}}<ng-container *ngIf="showQueueSelect"><i class="arrow-down"></i></ng-container>
    </ng-container>

    <span *ngIf="showQueueSelect && game === 'cs2'" class="val-selector-up"></span>
    <span *ngIf="showQueueSelect && game === 'cs2'" class="val-selector-down"></span>
  </p>

  <!------------------------------------------------------------------------------------------------------------------
  LP selector standalone
  ------------------------------------------------------------------------------------------------------------------->
  <p *ngIf="(showLpSelect || showLp) && game === 'none'" style="margin-top: 10px;" class="flag-lp"
     [class.editable-small-modern]="showLpSelect && (game === 'apex')"
     (click)="onOpenLpSelector()">
    <span *ngIf="game === 'apex'" class="val-selector-up"></span>
    <span *ngIf="game === 'apex'" class="val-selector-down"></span>
    <small>{{lpLabel}}</small>
    <ng-container *ngIf="game === 'apex'">
      {{minLp}}-{{maxLp}} <i class="arrow-down"></i>
    </ng-container>
  </p>


  <!------------------------------------------------------------------------------------------------------------------
  Platform & server selector
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="(showPlatform && showRegionSelect) && game === 'overwatch'" style="padding-top: 10px;padding-left: 13px;padding-right: unset;" class="flag-row">
    <div class="flag-col">
      <p class="flag-region"
         [class.editable-small-modern]="showRegionSelect && (game === 'apex' || game === 'overwatch')"
         (click)="onOpenRegionSelector()">
        <small>{{ 'server' | translate: lang }}</small>
        {{server || '-'}} <i class="arrow-down"></i>
      </p>
    </div>
    <div *ngIf="showPlatformSelect || showPlatform" class="flag-col" >
      <p class="flag-platform"
         *ngIf="showPlatform"
         [class.editable-small-modern]="showPlatformSelect && (game === 'apex' || game === 'overwatch')"
         (click)="showPlatformSelect && onOpenPlatformSelector()">
        <small>{{ 'platform' | translate: lang }}</small>
        <ng-container>{{ platform || uppercase }}</ng-container>
        <!-- <ng-container *ngIf="platform === 'pc'">PC</ng-container>
        <ng-container *ngIf="platform === 'psn'">PSN</ng-container>
        <ng-container *ngIf="platform === 'xbox'">XBOX</ng-container> -->
        <ng-container *ngIf="showPlatformSelect">&nbsp;<i class="arrow-down"></i></ng-container>
      </p>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Queue selector
  ------------------------------------------------------------------------------------------------------------------->
  <p *ngIf="(showQueueSelect || showQueue) && (game === 'overwatch')"
    class="flag-queue"
    [class.editable]="showQueueSelect && (game === 'lol' || game === 'tft' || game === 'wild-rift') && (game !== 'apex')"
    [class.editable-small-modern]="showQueueSelect && (game === 'valorant' || game === 'apex' || game === 'overwatch')"
    (click)="showQueueSelect && onOpenQueueSelector()"

  >
    <small>{{ 'queue' | translate: lang }}</small>
    <ng-container>{{queue}}</ng-container>
    <ng-container *ngIf="showQueueSelect">&nbsp;<i class="arrow-down"></i></ng-container>
  </p>

  <!------------------------------------------------------------------------------------------------------------------
  LP selector and  & platform
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="(showPlatform || showRegion || showLpSelect || showLp) && (game === 'apex' || game === 'marvel') && service !== 'placements' && service !== 'badges'" style="padding-top: 10px;padding-left: unset;padding-right: unset;" class="flag-row">
    <div class="flag-col" *ngIf="showLpSelect || showLp && (game === 'apex' || game === 'marvel')">
      <p class="flag-lp"
         [class.editable-small-modern]="showLpSelect"
         (click)="onOpenLpSelector()">
        <span *ngIf="game === 'apex' || game === 'marvel'" class="val-selector-up"></span>
        <span *ngIf="game === 'apex' || game === 'marvel'" class="val-selector-down"></span>
        <small [style.font-weight]="state ?  '700': ''">{{lpLabel}}</small>
        <ng-container *ngIf="state; else default">
          {{minLp}}
        </ng-container>
        <ng-template #default>
          {{minLp}}-{{maxLp}} <i class="arrow-down"></i>
        </ng-template>
      </p>
    </div>
    <div class="flag-col" *ngIf="showPlatformSelect || showPlatform ">
      <p class="flag-platform"
         *ngIf="showPlatform"
         [class.editable-small-modern]="showPlatformSelect && (game === 'apex' || game === 'marvel')"
         (click)="showPlatformSelect && onOpenPlatformSelector()">
        <span *ngIf="game === 'apex' || game === 'marvel'" class="val-selector-up"></span>
        <span *ngIf="game === 'apex' || game === 'marvel'" class="val-selector-down"></span>
        <small>{{ 'platform' | translate: lang }}</small>
        <ng-container>{{ platform || uppercase }}</ng-container>
        <!-- <ng-container *ngIf="platform === 'pc'">PC</ng-container>
        <ng-container *ngIf="platform === 'psn'">PSN</ng-container>
        <ng-container *ngIf="platform === 'xbox'">XBOX</ng-container> -->
        <ng-container *ngIf="showPlatformSelect">&nbsp;<i class="arrow-down"></i></ng-container>
      </p>
    </div>
  </div>


  <!------------------------------------------------------------------------------------------------------------------
  Region Standalone
  ------------------------------------------------------------------------------------------------------------------->
  <div style="padding-top: 10px;" class="flag-col" *ngIf="(showRegionSelect || showRegion) && (game === 'apex' || game === 'cs2' || game === 'marvel')">
    <p class="flag-region" [class.editable-small-modern]="showRegionSelect" (click)="onOpenRegionSelector()">
      <span *ngIf="game === 'apex' || game === 'cs2' || game === 'marvel'" class="val-selector-up"></span>
      <span *ngIf="game === 'apex' || game === 'cs2' || game === 'marvel'" class="val-selector-down"></span>
      <small *ngIf="game === 'apex' || game === 'cs2' || game === 'marvel'">{{ 'region' | translate: lang }}</small>
      <!-- <small *ngIf="game === 'cs2'">{{ 'region' | translate: lang }}</small> -->
      {{server || '-'}} <i class="arrow-down"></i>
    </p>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Map selector
  ------------------------------------------------------------------------------------------------------------------->
  <p
    class="flag-map editable-small-modern"
    *ngIf="showMap"
    (click)="onOpenMapSelector()"
  >
    <span class="val-selector-up"></span>
    <span class="val-selector-down"></span>
    <small>{{ 'map' | translate: lang }}</small>
    {{map}}
  </p>

  <!------------------------------------------------------------------------------------------------------------------
  LP & Server selector
  ------------------------------------------------------------------------------------------------------------------->
  <div *ngIf="(showRegionSelect || showLpSelect || showRegion || showLp) && (game === 'lol' || game === 'tft' || game === 'wild-rift' || game === 'valorant' )" class="flag-row"  style="padding-left: 0;padding-right: 0; padding-top: 10px;">
    <div *ngIf="showRegionSelect || showRegion" class="flag-col">
      <p class="flag-region"
         [class.editable]="showRegionSelect && (game === 'lol' || game === 'tft' || game === 'wild-rift')"
         [class.editable-small-modern]="showRegionSelect && (game === 'valorant')"
         (click)="onOpenRegionSelector()">
        <span *ngIf="game === 'valorant'" class="val-selector-up"></span>
        <span *ngIf="game === 'valorant'" class="val-selector-down"></span>
        <small>{{ (game === 'valorant' || game === 'tft' || game === 'lol' || game === 'wild-rift' ? 'region' : 'server') | translate: lang }}</small>
        {{server || '-'}} <i class="arrow-down"></i>
      </p>
    </div>
    <div *ngIf="showLpSelect || showLp" class="flag-col">
      <p class="flag-lp"
         [class.editable]="showLpSelect && (game === 'lol' || game === 'tft' || game === 'wild-rift')"
         [class.editable-small-modern]="showLpSelect && (game === 'valorant')"
         (click)="onOpenLpSelector()">
        <span *ngIf="game === 'valorant'" class="val-selector-up"></span>
        <span *ngIf="game === 'valorant'" class="val-selector-down"></span>
        <small [style.font-weight]="showRank ?  '700': ''">{{promos ? 'Promos' : lpLabel}}</small>
        <ng-container *ngIf="!promos">
          <ng-container *ngIf="state; else default">
            {{minLp}}
          </ng-container>

          <ng-template #default>
            <ng-container *ngIf="game !== 'wild-rift'" >
              {{minLp}}-{{maxLp}} <i class="arrow-down"></i>
            </ng-container>

            <ng-container *ngIf="game === 'wild-rift'">{{minLp}}</ng-container>
          </ng-template>

        </ng-container>
        <ng-container *ngIf="promos">
          <i
            *ngFor="let promo of promos.split('');"
            class="fa"
            [class.ion-md-checkmark]="promo === 'w'"
            [class.ion-md-close]="promo === 'l'"
            [class.ion-md-remove]="promo === 'n'"
          > </i>
          <i style="margin-left: 5px;" class="arrow-down"></i>
        </ng-container>
      </p>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Platform Standalone
  ------------------------------------------------------------------------------------------------------------------->
  <div class="flag-row" style="padding-left: 0;padding-right: 0; padding-top: 10px;"
       *ngIf="(showPlatform || showRegion) && ((game === 'apex'  && (service === 'placements' || service === 'badges')) || game === 'valorant')">
    <div class="flag-col" *ngIf="showPlatformSelect || showPlatform ">
      <p class="flag-platform"
         *ngIf="showPlatform"
         [class.editable-small-modern]="showPlatformSelect && (game === 'apex' || game === 'valorant')"
         (click)="showPlatformSelect && onOpenPlatformSelector()">
        <span *ngIf="game === 'apex' || game === 'valorant'" class="val-selector-up"></span>
        <span *ngIf="game === 'apex' || game === 'valorant'" class="val-selector-down"></span>
        <small>{{ 'platform' | translate: lang }}</small>
        <ng-container>{{ platform || uppercase }}</ng-container>
        <!-- <ng-container *ngIf="platform === 'pc'">PC</ng-container>
        <ng-container *ngIf="platform === 'psn'">PSN</ng-container>
        <ng-container *ngIf="platform === 'xbox'">XBOX</ng-container> -->
        <ng-container *ngIf="showPlatformSelect">&nbsp;<i class="arrow-down"></i></ng-container>
      </p>
    </div>
  </div>

  <!------------------------------------------------------------------------------------------------------------------
  Time left display
  ------------------------------------------------------------------------------------------------------------------->
  <div class="flag-lp flag-stat mb-2" *ngIf="showTimeLeft">
        <span class="d-block font-weight-bold">
            {{ 'estimated_time_left' | translate: lang }}
        </span>
    <span class="flag_lp d-block flag-text-md text-bj">
            {{ timeLeft }}
        </span>
  </div>
</app-flag-container-v2>